<div class="toaster-bar" role="alert" aria-live="assertive" aria-atomic="true" [ngStyle]="{ 'top': options?.top }">
	<div class="toaster-bar-body">

		<ng-container *ngIf="data?.type == toasterTypeEnum.Success">
			<!-- Based on requirement can add other conditions -->
			<span class="toaster-bar-image toaster-bar-success" role="img" aria-hidden="true">
			</span>
		</ng-container>

		<!-- Toaster messsage -->
		<span id="toasterTextBtn" (focusout)="closeToasteronParentFocus()" class="toaster-bar-text" tabindex="1"
			aria-live="polite">{{ data?.message}}
		</span>

		<!-- Close btn -->
		<button id="toasterCloseBtn" class="toaster-bar__close" type="button" role="button" aria-label="close"
			tabindex="2" (click)="closeToasterEvent()" (keydown)="closeToasterEventFromKey($event)">
			<span class="toaster-bar__close__icon" role="img" aria-hidden="true"></span>
		</button>
		
	</div>
</div>